@charset "UTF-8";
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]){
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*){
  pointer-events: none;
}

:host{
  margin: 0px;
  margin-block-end: 1px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  background-color: var(--calcite-color-foreground-1);
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  color: var(--calcite-color-text-1);
  --tw-shadow: 0 1px 0 var(--calcite-color-border-3);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition: background-color var(--calcite-animation-timing);
  animation: calcite-fade-in var(--calcite-animation-timing);
}
:host *{
  box-sizing: border-box;
}

.label{
  display: flex;
  flex: 1 1 auto;
  cursor: pointer;
  align-items: center;
  background-color: transparent;
  outline-color: transparent;
}
.label:focus{
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.label:hover{
  background-color: var(--calcite-color-foreground-2);
}

:host([non-interactive]:hover){
  background-color: var(--calcite-color-foreground-1);
}

:host([non-interactive]) .label,
:host([non-interactive]) .icon{
  pointer-events: none;
}

.icon{
  margin-block: 0px;
  display: flex;
  cursor: pointer;
  align-items: center;
  padding: 0.25rem;
  color: var(--calcite-color-brand);
  flex: 0 0 auto;
  line-height: 0;
}
.icon:hover{
  background-color: var(--calcite-color-foreground-2);
}

.icon-dot{
  display: flex;
  inline-size: 1.5rem;
  align-items: center;
  padding: 0.5rem;
}
.icon-dot::before{
  opacity: 0;
  content: "•";
}

.icon calcite-icon{
  opacity: 0;
}

:host([selected]) .icon-dot::before,
:host([selected]) .icon calcite-icon {
  transition: opacity var(--calcite-animation-timing);
  opacity: 1;
}

.text-container{
  pointer-events: none;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: hidden;
  padding-block: 0.5rem;
  padding-inline: 0.75rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  word-wrap: break-word;
  word-break: break-word;
}

.title{
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-1);
}

.description{
  margin-block-start: 0.125rem;
  font-weight: var(--calcite-font-weight-normal);
  color: var(--calcite-color-text-3);
}

.actions{
  margin: 0px;
  display: flex;
  flex: 0 1 auto;
  align-items: stretch;
  justify-content: flex-end;
}

.actions--start ~ .label {
  padding-inline-start: 0.25rem;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]){
  display: none;
}

[hidden]{
  display: none;
}